import { UnderlinedLink } from '@/components/shared/UnderlinedLink';
import { useUser } from '@/contexts/user/UserContext';
import { useEarningPermission } from '@/lib/hooks/useEarningPermission';

export const UserDetailLink = ({
    userId,
    name
}: {
    userId?: string | null;
    name?: string | null;
}) => {
    const { user } = useUser();
    const { accessToUserEarningsAllowed } = useEarningPermission(user.role);
    return (
        <span>
            {accessToUserEarningsAllowed() ? (
                <UnderlinedLink
                    href={`/users/${userId}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    {name}
                </UnderlinedLink>
            ) : (
                name
            )}
        </span>
    );
};
